module.exports = "/packs/satisfaction-check-cff717a493317475ba8800c6d351258e.svg";